import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['modal', 'periodSelect', 'dateRange', 'fromDate', 'toDate', 'downloadLink']
  static values = { baseUrl: String }

  connect() {
    this.toggleDateRange()
  }

  show(event) {
    event.preventDefault()
    this.modalTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  hide(event) {
    if (event) {
      event.preventDefault()
    }
    this.modalTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  backdropClick(event) {
    if (event.target === this.modalTarget) {
      this.hide(event)
    }
  }

  periodChange() {
    this.toggleDateRange()
    this.updateDownloadLink()
  }

  dateChange() {
    this.updateDownloadLink()
  }

  toggleDateRange() {
    if (this.hasPeriodSelectTarget && this.hasDateRangeTarget) {
      if (this.periodSelectTarget.value === 'custom') {
        this.dateRangeTarget.classList.remove('hidden')
      } else {
        this.dateRangeTarget.classList.add('hidden')
      }
    }
  }

  updateDownloadLink() {
    if (!this.hasDownloadLinkTarget) return

    const period = this.periodSelectTarget.value
    let url = `${this.baseUrlValue}?period=${period}`

    if (period === 'custom') {
      const fromDate = this.fromDateTarget.value
      const toDate = this.toDateTarget.value
      if (fromDate) url += `&from_date=${fromDate}`
      if (toDate) url += `&to_date=${toDate}`
    }

    this.downloadLinkTarget.href = url
  }

  download(event) {
    // Allow the download to proceed, then close the modal
    setTimeout(() => this.hide(), 100)
  }
}
